import Select from './view/mobile';

export default Select;
